/*=============================================== Modal ===============================================*/
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*==================== Imports ====================*/
import React, { useEffect } from "react";
import styled from "styled-components";
import Variables from "./Variables";
import Mixins from "./Mixins";
import Icon from "./Icon";
import FajnyIcon from "./FajnyIcon";
/*==================== Component ====================*/
var Modal = function (_a) {
    var children = _a.children, isOpen = _a.isOpen, close = _a.close, iconClose = _a.iconClose, _b = _a.fajnyIconClose, fajnyIconClose = _b === void 0 ? "close-solid" : _b, props = __rest(_a, ["children", "isOpen", "close", "iconClose", "fajnyIconClose"]);
    useEffect(function () {
        isOpen ? document.body.classList.add("stop-scrolling") : document.body.classList.remove("stop-scrolling");
    });
    return (React.createElement(Container, __assign({ "$isOpen": isOpen }, props),
        close && (React.createElement(CloseButton, { onClick: close }, iconClose ? (React.createElement(Icon, { src: iconClose, size: 32, color: Variables.Colors.White })) : (React.createElement(FajnyIcon, { name: fajnyIconClose, size: 32, color: Variables.Colors.White })))),
        React.createElement(Content, null, children)));
};
export default Modal;
/*==================== Styles ====================*/
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 9999;\n    width: 100vw;\n    height: 100vh;\n    display: ", ";\n    align-items: center;\n    justify-content: center;\n    background-color: ", ";\n"], ["\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 9999;\n    width: 100vw;\n    height: 100vh;\n    display: ", ";\n    align-items: center;\n    justify-content: center;\n    background-color: ", ";\n"])), function (_a) {
    var $isOpen = _a.$isOpen;
    return ($isOpen ? "flex" : "none");
}, Variables.Overlays.Plain.Black80);
var Content = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: 90%;\n    height: 90%;\n    position: relative;\n    z-index: 1;\n    ", ";\n"], ["\n    width: 90%;\n    height: 90%;\n    position: relative;\n    z-index: 1;\n    ", ";\n"])), Mixins.Flexbox({
    $align: "center",
    $justify: "center",
}));
var buttonSize = 48;
var CloseButton = styled.button(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    position: absolute;\n    top: ", ";\n    right: ", ";\n    width: ", "px;\n    height: ", "px;\n    border-radius: ", ";\n    border: none;\n    background-color: transparent;\n    transition: ", ";\n    ", ";\n    z-index: 20;\n\n    @media ", " {\n        &:hover {\n            background-color: ", ";\n        }\n    }\n"], ["\n    position: absolute;\n    top: ", ";\n    right: ", ";\n    width: ", "px;\n    height: ", "px;\n    border-radius: ", ";\n    border: none;\n    background-color: transparent;\n    transition: ", ";\n    ", ";\n    z-index: 20;\n\n    @media ", " {\n        &:hover {\n            background-color: ", ";\n        }\n    }\n"])), Variables.Spacers.XXL, Variables.Spacers.XXL, buttonSize, buttonSize, Variables.Radiuses.Circle, Variables.Transitions.Short, Mixins.Flexbox({
    $align: "center",
    $justify: "center",
}), Variables.Breakpoints.Hover, Variables.Colors.Gray800);
var templateObject_1, templateObject_2, templateObject_3;
